var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ww-scroll-wrap",class:_vm.barType},[_c('div',{staticClass:"ww-scroll-box",style:(_vm.boxStyle),on:{"mousedown":_vm.handleDown}})])}
var staticRenderFns = []

export { render, staticRenderFns }